<span class="onboarding-badge" [class]="'onboarding-badge--' + status().toLowerCase()">
  {{ 'app.admin.users.onboardingStatus.' + status() | translate }}
</span>
